import { render } from "./IconPriorityHigh.vue?vue&type=template&id=153fd667"
import script from "./IconPriorityHigh.vue?vue&type=script&lang=js"
export * from "./IconPriorityHigh.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__